$CLASS: '.joy-option';

:host {
    --option-color-bg: white;
    --option-color: var(--joy-color-neutral-60);
    --option-padding: var(--joy-core-spacing-2) var(--joy-core-spacing-4);

    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: var(--option-font-size);
    width: 100%;
    min-height: var(--option-height);
    padding: var(--option-padding);
    margin: 0;
    background: var(--option-color-bg);
    color: var(--option-color);
    transition: all var(--joy-transition-duration-short) var(--joy-transition-timing-function);
    box-sizing: border-box;
}

:host(#{$CLASS}_selected),
:host(:hover) {
    --option-color: var(--joy-color-secondary-50);
    --option-color-bg: var(--joy-color-secondary-10);
}

:host(#{$CLASS}_disabled) {
    cursor: default;
    --option-color: var(--joy-color-neutral-40);
    --option-color-bg: var(--joy-color-neutral-10);
}